export function formatDate(dateString) {
  const date = new Date(dateString);
  const options = { month: 'long', year: 'numeric' };
  const fullDate = date.toLocaleString('en-US', options);

  // Extract the first 4 characters of the month
  const month = fullDate.substring(0, 3);

  return `${month} ${date.getFullYear()}`;
}